import { Ref, computed } from "vue";
import { AppData } from "@/models/application";
import { loanConfigurationActions } from "@/composables/mapActions";
import { RatePlanVM, RatePlanRepaymentVM } from "@/models/loanConfiguration";

export default function useApplicationRatePlans(store: any) {
  const {
    setLoading,
    setSavingChanges,
    setSelectedRepaymentOption,
    setSelectedRatePlan,
    setSelectedRateTypeId,
  } = loanConfigurationActions();

  const fixedRatePlans = computed<RatePlanVM[]>(
    () => store.state.loanConfigurationModule.fixedRatePlans,
  );

  const error = computed<boolean>(() => store.state.loanConfigurationModule.error);

  const loanConfigurationModule = computed(() => store.state.loanConfigurationModule);

  const variableRatePlans = computed<RatePlanVM[]>(
    () => store.state.loanConfigurationModule.variableRatePlans,
  );

  const previouslySelectedRatePlan = computed<RatePlanVM | undefined>(
    () => store.state.loanConfigurationModule?.loanOptionsConfiguration?.selectedRatePlan,
  );

  const selectedRatePlan = computed<RatePlanVM | undefined>(
    () => store.state.loanConfigurationModule.selectedRatePlan,
  );

  const selectedRepaymentOption = computed<RatePlanRepaymentVM | undefined>(
    () => store.state.loanConfigurationModule.selectedRepaymentOption,
  );

  const previouslySelectedSchool = computed(
    () => store.getters["loanConfigurationModule/selectedSchool"],
  );

  const previouslySelectedRepaymentOption = computed(
    () => store.state.loanConfigurationModule.loanOptionsConfiguration.selectedRepaymentOption,
  );

  const savingChanges = computed<boolean>(() => store.state.loanConfigurationModule.savingChanges);

	const gettingRatePlans = computed<boolean>(() => store.state.loanConfigurationModule.loading);

  function getRatePlansByRateTypeId(rateTypeId: number) {
    if (rateTypeId === 1) {
      return fixedRatePlans.value;
    } else if (rateTypeId === 2) {
      return variableRatePlans.value;
    } else {
      return [];
    }
  }

  function setDefaultRatePlan(ratePlans: RatePlanVM[]) {
    if (ratePlans.length === 1) {
      setSelectedRatePlan(ratePlans[0]);
    }
  }

  async function getRatePlansAsync() {
    await store.dispatch("loanConfigurationModule/getAvailableRatePlans");
  }

  return {
    error,
    fixedRatePlans,
    loanConfigurationModule,
    previouslySelectedRatePlan,
    previouslySelectedRepaymentOption,
    previouslySelectedSchool,
    selectedRatePlan,
    variableRatePlans,
    selectedRepaymentOption,
		gettingRatePlans,
    savingChanges,
    getRatePlansByRateTypeId,
    setDefaultRatePlan,
    setLoading,
    setSavingChanges,
    getRatePlansAsync,
    setSelectedRatePlan,
    setSelectedRateTypeId,
    setSelectedRepaymentOption,
  };
}
